import { render, staticRenderFns } from "./NodeTag.vue?vue&type=template&id=6cade6aa&scoped=true"
import script from "./NodeTag.vue?vue&type=script&lang=js"
export * from "./NodeTag.vue?vue&type=script&lang=js"
import style0 from "./NodeTag.vue?vue&type=style&index=0&id=6cade6aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cade6aa",
  null
  
)

export default component.exports